<div
  [ngClass]="viewFilter ? 'example-container' : ''"
  class="scrollableDrawer"
  style="overflow: auto"
  [style.height.px]="pageFromRoom ? height : null"
  (window:resize)="pageFromRoom ? onResize($event) : null">
  <div class="container">
    <div class="row">
      <div id="filterpan" class="web-filter-card modal fade" style="margin-top: 30px" class="col-xs-12 col-xl-6 col-wrapper">
        <mat-card class="offers-filter_panel">
          <mat-card-header>
            <mat-card-title>
              <h3 class="filter_color_offers">{{ rGuestBookMessages.offer.offerFilterLabel }}</h3>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="filter-offers-page row">
              <div *ngIf="!pageFromRoom && !isIE11" class="col-xs-3 col-sm-4 col-md-3 col-lg-3 custom-filter-col">
                <mat-form-field>
                  <input
                    name="date"
                    autocomplete="off"
                    [(ngModel)]="ArrDepDate"
                    #ctrl="ngModel"
                    [minDate]="minDate"
                    readonly
                    (ngModelChange)="validatedates(ArrDepDate)"
                    matInput
                    placeholder="{{ rGuestBookMessages.offer.offerArrDepPlaceholder }}"
                    (onShown)="onShowPicker($event)"
                    bsDaterangepicker
                    [bsConfig]="bsConfig"
                    #dpr="bsDaterangepicker" />
                </mat-form-field>
              </div>
              <div *ngIf="!pageFromRoom && isIE11" class="filter-fields col-xs-3 col-sm-3 col-md-3 col-lg-3">
                <mat-form-field>
                  <input
                    matInput
                    #arrDate1="ngModel"
                    [(ngModel)]="IEarrival"
                    [min]="minDate"
                    (ngModelChange)="validateArrDate(IEarrival)"
                    [matDatepicker]="arrPicker"
                    placeholder="{{ rGuestBookMessages.offer.offerIEArrivalDatePlaceholder || 'Arrival Date' }}" />
                  <mat-datepicker-toggle matSuffix [for]="arrPicker"></mat-datepicker-toggle>
                  <mat-datepicker panelClass="arrDatePickerCard" #arrPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div *ngIf="!pageFromRoom && isIE11" class="filter-fields col-xs-3 col-sm-3 col-md-3 col-lg-3">
                <mat-form-field>
                  <input
                    matInput
                    #depDate1="ngModel"
                    [(ngModel)]="IEdeparture"
                    [min]="IEarrival"
                    (ngModelChange)="validateDepDate(IEdeparture)"
                    [matDatepicker]="depPicker"
                    placeholder="{{ rGuestBookMessages.offer.offerIEDepartureDatePlaceholder || 'Departure Date' }}" />
                  <mat-datepicker-toggle matSuffix [for]="depPicker"></mat-datepicker-toggle>
                  <mat-datepicker panelClass="depDatePickerCard" #depPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-xs-3 col-sm-4 col-md-3 col-lg-3 custom-filter-col">
                <mat-form-field>
                  <input
                    class="offerCode_textbox"
                    name="OfferCode"
                    [(ngModel)]="OfferCode"
                    (keyup)="offerCodeEntry($event)"
                    matInput
                    #ctrl="ngModel"
                    (focus)="storePrviousOffer()"
                    (blur)="offerCodeSearch()"
                    placeholder="{{ rGuestBookMessages.offer.offerOfferCodePlaceholder }}" />
                </mat-form-field>
              </div>
              <div class="col-xs-3 col-sm-4 col-md-6 col-lg-3 surface-duo">
                <button
                  *ngIf="!rGuestBookPermissions.functionalPermissions.enableAutoSearch"
                  (click)="searchOffers('offer')"
                  [disabled]="basicOfferPreload"
                  mat-raised-button
                  data-dismiss="modal"
                  class="search_button mat-sm-btn">
                  {{ rGuestBookMessages.offer.offerSearchButton }}
                </button>
              </div>
              <div class="col-xs-3 col-sm-4 col-md-6 col-lg-3 surface-duo" *ngIf="rGuestBookPermissions.routePermissions.calendar">
                <button (click)="navigateToCalendar()" mat-raised-button class="calendarNavigationBtn search_button">
                  {{ rGuestBookMessages.rooms.roomTabFlexibleDates }}
                </button>
              </div>
            </div>
          </mat-card-content>
          <mat-card-actions class="offers-filter-actions">
            <button [hidden]="clearFilter || pageFromRoom" (click)="clear_Filter()" type="button" class="clear_filter btn btn-danger">
              {{ rGuestBookMessages.offer.offerClearButton }}
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
      <div class="calendarNavigationMobile" *ngIf="rGuestBookPermissions.routePermissions.calendar">
        <button (click)="navigateToCalendar()" mat-raised-button class="calendarNavigationBtn search_button">
          {{ rGuestBookMessages.rooms.roomTabFlexibleDates }}
        </button>
      </div>
      <div class="filter-button">
        <button mat-fab class="button-color" (click)="openFilterDialog()">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </button>
      </div>

      <div style="margin-top: 20px" class="col-xs-12 col-xl-8 col-wrapper" [ngClass]="pageFromRoom ? 'marginOfferPage' : ''">
        <div
          style="margin-top: 10px"
          class="col-lg-offset-3 col-lg-6 col-md-12 col-sm-12 col-xs-12"
          *ngIf="!rGuestBookPermissions.functionalPermissions.bestOffers && !rGuestBookPermissions.functionalPermissions.casinoOffers">
          <div class="alert alert-danger" role="alert" style="word-break: break-word">
            <strong>{{ rGuestBookMessages.offer.offerMessage6 }}</strong>
          </div>
        </div>

        <mat-tab-group [selectedIndex]="selectedTab" (selectedIndexChange)="tabIndexChange($event)" class="offers-tab-head">
          <mat-tab
            *ngIf="rGuestBookPermissions.functionalPermissions.bestOffers"
            label="{{ rGuestBookMessages.offer.offerTabBestOffer }}"
            class="mattabHeaderOffers matTabBestOffers">
            <ng-template mat-tab-label>
              <span class="mdl-badge matTabBestOffersBadge" [attr.data-badge]="totalBasicOffers || '- '">{{
                rGuestBookMessages.offer.offerTabBestOffer
              }}</span>
            </ng-template>
            <div>
              <div style="margin-top: 10px" class="col-lg-offset-3 col-lg-6 col-md-12 col-sm-12 col-xs-12" *ngIf="offerError">
                <div class="alert alert-danger" style="word-break: break-word" role="alert">
                  <strong>{{ offerError }}</strong>
                </div>
              </div>
            </div>
            <div style="margin-top: 20px" class="grid-wrapper">
              <div
                id="basicOfferList"
                class="offer_card_margin col-xs-12 col-sm-6 col-md-6 col-lg-6 col-sm-12"
                infiniteScroll
                [infiniteScrollDistance]="2"
                [infiniteScrollDisabled]="stopBasicOfferScroll"
                [scrollWindow]="true"
                [infiniteScrollThrottle]="150"
                (scrolled)="onbasicOfferListScroll()"
                [fromRoot]="pageFromRoom ? true : null"
                [infiniteScrollContainer]="pageFromRoom ? scrollableDrawer : null"
                *ngFor="let offer of basicOfferList; let i = index; let odd = odd; let even = even">
                <div>
                  <div id="mat-card{{ i }}" class="offers-card">
                    <div id="carousel-id{{ i }}" class="carousel slide carouselCardImage" data-ride="carousel" data-interval="false">
                      <ol class="carousel-indicators" *ngIf="offer.offerImageList.length > 1">
                        <ng-container *ngFor="let img of offer.offerImageList; let ii = index">
                          <li
                            [attr.data-target]="'#carousel-id' + i"
                            [attr.data-slide-to]="ii"
                            [class.active]="ii == 0"
                            *ngIf="img != ''"></li>
                        </ng-container>
                      </ol>
                      <div class="carousel-inner carouselCardImageContainer">
                        <ng-container *ngFor="let img of offer.offerImageList; let ii = index">
                          <div class="item carousel-item" [class.active]="ii == 0">
                            <ng-container>
                              <img
                                [src]="assetsURL + 'offers/' + (offer.offer | azurefolder) + '/' + (img | azurefolder) | azureBlobToken"
                                [attr.alt]="offer.offer"
                                (error)="errorofferImageHandler($event, i, ii, 'best')" />
                            </ng-container>
                          </div>
                        </ng-container>
                        <div class="item active" *ngIf="offer.offerImageList.length == 0">
                          <img [src]="defaultOfferImageURL | azureBlobToken" [attr.alt]="offer.offer" />
                        </div>
                      </div>
                      <ng-container *ngIf="offer.offerImageList.length > 1">
                        <a class="carousel-control-prev" [attr.href]="'#carousel-id' + i" data-slide="prev">
                          <i aria-hidden="true" class="carousel-control-prev-icon"></i>
                        </a>
                        <a class="carousel-control-next" [attr.href]="'#carousel-id' + i" data-slide="next">
                          <i aria-hidden="true" class="carousel-control-next-icon"></i>
                        </a>
                      </ng-container>
                    </div>
                    <div class="mobile-offer-button">
                      <a [hidden]="!viewDetailsButton" class="mobile-details-btn content-spacer" (click)="getOfferDetails(offer)">{{
                        rGuestBookMessages.offer.offerDetailsButton
                      }}</a>

                      <a
                        [hidden]="!viewBookButton"
                        (click)="tooltip.show()"
                        matTooltipPosition="right"
                        matTooltip="{{ offer.offerNotValidReason }} {{
                          offer.offerNotValidReason == 'Available for sale only from'
                            ? (offer.earliestSalesDate | date: 'EEEE, MMM d, y')
                            : (offer.latestSalesDate | date: 'EEEE, MMM d, y')
                        }}"
                        class="mobile-book-btn link-disabled"
                        [attr.disabled]="!offer.isOfferValid"
                        *ngIf="!offer.isOfferValid"
                        >{{ rGuestBookMessages.offer.offerBookButton }}</a
                      >

                      <a
                        [hidden]="!viewSelectButton"
                        (click)="tooltip.show()"
                        matTooltipPosition="right"
                        matTooltip="{{ offer.offerNotValidReason }} {{
                          offer.offerNotValidReason == 'Available for sale only from'
                            ? (offer.earliestSalesDate | date: 'EEEE, MMM d, y')
                            : (offer.latestSalesDate | date: 'EEEE, MMM d, y')
                        }}"
                        class="mobile-book-btn link-disabled"
                        [attr.disabled]="!offer.isOfferValid"
                        *ngIf="!offer.isOfferValid"
                        >{{ rGuestBookMessages.offer.offerSelectButton }}</a
                      >
                      <span
                        *ngIf="isIOS"
                        class="matTooltipShow"
                        matTooltipPosition="right"
                        matTooltip="{{ offer.offerNotValidReason }} {{
                          offer.offerNotValidReason == 'Available for sale only from'
                            ? (offer.earliestSalesDate | date: 'EEEE, MMM d, y')
                            : (offer.latestSalesDate | date: 'EEEE, MMM d, y')
                        }}"
                        #tooltip="matTooltip"></span>

                      <a
                        [hidden]="!viewBookButton"
                        class="mobile-book-btn content-spacer"
                        (click)="checkAndBook(offer)"
                        aria-hidden="true"
                        *ngIf="offer.isOfferValid"
                        >{{ rGuestBookMessages.offer.offerBookButton }}</a
                      >
                      <a
                        [hidden]="!viewSelectButton"
                        class="mobile-book-btn content-spacer"
                        (click)="checkAndBook(offer)"
                        aria-hidden="true"
                        *ngIf="offer.isOfferValid"
                        >{{ rGuestBookMessages.offer.offerSelectButton }}</a
                      >
                    </div>
                    <div class="offer_code">
                      <strong id="offerCodeCard">{{ rGuestBookMessages.offer.offerOfferCodeCardLabel }}</strong> {{ offer.offer }}
                    </div>
                    <div class="card_title">
                      <h4
                        *ngIf="rGuestBookPermissions.functionalPermissions.disableCapitalizePipe"
                        class="card_title_text pull-left offer_name">
                        {{ offer.offerDescription }}
                      </h4>
                      <h4
                        *ngIf="!rGuestBookPermissions.functionalPermissions.disableCapitalizePipe"
                        class="card_title_text pull-left offer_name">
                        {{ offer.offerDescription | capitalize }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: block" class="col-xl-12">
                <div *ngIf="basicOfferPreload && !offerError">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="text-center">
                      <i class="animated-preload1 fa fa-circle faa-burst animated" aria-hidden="true"></i>
                      &nbsp;
                      <i class="animated-preload2 fa fa-circle faa-burst animated" aria-hidden="true"></i>&nbsp;
                      <i class="animated-preload3 fa fa-circle faa-burst animated" aria-hidden="true"></i>&nbsp;
                    </div>
                  </div>
                </div>
                <div *ngIf="basicOfferPreloadEnd && !offerError">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="text-center">
                      <i class="preload-end fa fa-circle" aria-hidden="true"></i>&nbsp;
                      <i class="preload-end fa fa-circle" aria-hidden="true"></i>&nbsp;
                      <i class="preload-end fa fa-circle" aria-hidden="true"></i>&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>

          <mat-tab
            class="matTabCasinoOffers"
            *ngIf="rGuestBookPermissions.functionalPermissions.casinoOffers"
            label="{{ rGuestBookMessages.offer.offerTabCasinoOffer }}">
            <ng-template mat-tab-label>
              <span class="mdl-badge matTabCasinoOffersBadge" [attr.data-badge]="casinoList.length || '- '">{{
                rGuestBookMessages.offer.offerTabCasinoOffer
              }}</span>
            </ng-template>
            <div *ngIf="casinoData"></div>
            <div class="container-fluid">
              <div
                *ngIf="casinoNumber.length <= 0 && !casinopreload && rGuestBookPermissions.functionalPermissions.casinoPanel_offersPage"
                class="casinorequiredpanel row">
                <div
                  class="col-xs-12 col-sm-12 col-md-offset-4 col-md-5 col-lg-offset-4 col-lg-3 custom-col-offset-4 custom-casino-col col-md-12">
                  <div class="panel panel-casinoRequired custom-casino-panel">
                    <div class="casino-panel panel-heading custom-casino-panel-heading">
                      {{ rGuestBookMessages.offer.offerCasinoNumberError }}
                    </div>
                    <div class="panel-body custom-panel-body">
                      <mat-form-field class="col-xs-12 col-sm-12 col-md-3 col-lg-2 col-md-12 col-lg-12">
                        <input
                          (keydown)="onCasinoKeydown($event)"
                          name="casinoNumberpanel"
                          [(ngModel)]="casinoNumberpanel"
                          matInput
                          #ctrl="ngModel"
                          placeholder="{{ rGuestBookMessages.offer.offerCasinoNumberInputPlaceholder }}" />
                      </mat-form-field>
                      <div class="search_panel_div">
                        <button [disabled]="!casinoNumberpanel" (click)="openDialog('panel')" mat-raised-button class="search_panel">
                          {{ rGuestBookMessages.offer.offerValidateButton }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- </div> -->
            <div
              style="margin-top: 10px"
              class="col-lg-offset-3 col-lg-6 col-md-12 col-sm-12 col-xs-12"
              *ngIf="!casinoOfferAvailable && casinoNumber.length > 0 && !casinopreload">
              <div class="alert alert-danger" style="word-break: break-word" role="alert">
                <strong *ngIf="totalBasicOffers > 0">{{ rGuestBookMessages.offer.offerMessage1 }}</strong>
                <strong *ngIf="totalBasicOffers <= 0">{{ casinoError }}</strong>
              </div>
            </div>
            <div [style.height.px]="defaultHeight">
              <div class="row-fluid casino-row-fluid grid-wrapper">
                <div
                  *ngFor="let casino of casinoList; let i = index; let odd = odd; let even = even"
                  class="offer_card_margin col-xs-12 col-sm-6 col-md-6 col-lg-6">
                  <div id="mat-card{{ i }}" class="offers-card">
                    <div id="carousel-id-casino{{ i }}" class="carousel slide carouselCardImage" data-ride="carousel" data-interval="false">
                      <ol class="carousel-indicators" *ngIf="casino.offerImageList.length > 1">
                        <ng-container *ngFor="let img of casino.offerImageList; let ii = index">
                          <li
                            [attr.data-target]="'#carousel-id-casino' + i"
                            [attr.data-slide-to]="ii"
                            [class.active]="ii == 0"
                            *ngIf="img != ''"></li>
                        </ng-container>
                      </ol>
                      <div class="carousel-inner carouselCardImageContainer">
                        <ng-container *ngFor="let img of casino.offerImageList; let ii = index">
                          <div class="item carousel-item" [class.active]="ii == 0">
                            <ng-container>
                              <img
                                [src]="assetsURL + 'offers/' + (casino.offer | azurefolder) + '/' + (img | azurefolder) | azureBlobToken"
                                [attr.alt]="casino.offer"
                                (error)="errorofferImageHandler($event, i, ii, 'casino')" />
                            </ng-container>
                          </div>
                        </ng-container>
                        <div class="item active" *ngIf="casino.offerImageList.length == 0">
                          <img [src]="defaultOfferImageURL | azureBlobToken" [attr.alt]="casino.offer" />
                        </div>
                      </div>

                      <ng-container *ngIf="casino.offerImageList.length > 1">
                        <a class="carousel-control-prev" [attr.href]="'#carousel-id-casino' + i" data-slide="prev">
                          <i aria-hidden="true" class="carousel-control-prev-icon"></i>
                        </a>
                        <a class="carousel-control-next" [attr.href]="'#carousel-id-casino' + i" data-slide="next">
                          <i aria-hidden="true" class="carousel-control-next-icon"></i>
                        </a>
                      </ng-container>
                    </div>
                    <div class="mobile-offer-button">
                      <a [hidden]="!viewDetailsButton" class="mobile-details-btn content-spacer" (click)="getOfferDetails(casino)">{{
                        rGuestBookMessages.offer.offerDetailsButton
                      }}</a>
                      <a
                        [hidden]="!viewBookButton"
                        matTooltipPosition="right"
                        matTooltip="{{ casino.offerNotValidReason }} {{
                          casino.offerNotValidReason == 'Available for sale only from'
                            ? (casino.earliestSalesDate | date: 'EEEE, MMM d, y')
                            : (casino.latestSalesDate | date: 'EEEE, MMM d, y')
                        }}"
                        class="mobile-book-btn link-disabled"
                        [attr.disabled]="!casino.isOfferValid"
                        *ngIf="!casino.isOfferValid"
                        >{{ rGuestBookMessages.offer.offerBookButton }}</a
                      >
                      <a
                        [hidden]="!viewSelectButton"
                        matTooltipPosition="right"
                        matTooltip="{{ casino.offerNotValidReason }} {{
                          casino.offerNotValidReason == 'Available for sale only from'
                            ? (casino.earliestSalesDate | date: 'EEEE, MMM d, y')
                            : (casino.latestSalesDate | date: 'EEEE, MMM d, y')
                        }}"
                        [attr.disabled]="!casino.isOfferValid"
                        (click)="tooltip.show()"
                        class="mobile-book-btn link-disabled"
                        *ngIf="!casino.isOfferValid"
                        >{{ rGuestBookMessages.offer.offerSelectButton }}</a
                      >
                      <span
                        *ngIf="isIOS"
                        class="matTooltipShow"
                        matTooltipPosition="right"
                        matTooltip="{{ casino.offerNotValidReason }} {{
                          casino.offerNotValidReason == 'Available for sale only from'
                            ? (casino.earliestSalesDate | date: 'EEEE, MMM d, y')
                            : (casino.latestSalesDate | date: 'EEEE, MMM d, y')
                        }}"
                        #tooltip="matTooltip"></span>
                      <a
                        [hidden]="!viewBookButton"
                        class="mobile-book-btn content-spacer"
                        (click)="checkAndBook(casino)"
                        aria-hidden="true"
                        *ngIf="casino.isOfferValid"
                        >{{ rGuestBookMessages.offer.offerBookButton }}</a
                      >
                      <a
                        [hidden]="!viewSelectButton"
                        class="mobile-book-btn content-spacer"
                        (click)="checkAndBook(casino)"
                        aria-hidden="true"
                        *ngIf="casino.isOfferValid"
                        >{{ rGuestBookMessages.offer.offerSelectButton }}</a
                      >
                    </div>
                    <div class="offer_code">
                      <strong id="casinoOfferCodeCard">{{ rGuestBookMessages.offer.offerOfferCodeCardLabel }}</strong> {{ casino.offer }}
                    </div>
                    <div class="card_title">
                      <h4
                        *ngIf="rGuestBookPermissions.functionalPermissions.disableCapitalizePipe"
                        class="card_title_text pull-left offer_name">
                        {{ casino.offerDescription }}
                      </h4>
                      <h4
                        *ngIf="!rGuestBookPermissions.functionalPermissions.disableCapitalizePipe"
                        class="card_title_text pull-left offer_name">
                        {{ casino.offerDescription | capitalize }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="casinopreload">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="text-center">
                    <i class="animated-preload1 fa fa-circle faa-burst animated" aria-hidden="true"></i>
                    &nbsp;
                    <i class="animated-preload2 fa fa-circle faa-burst animated" aria-hidden="true"></i>&nbsp;
                    <i class="animated-preload3 fa fa-circle faa-burst animated" aria-hidden="true"></i>&nbsp;
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="casinoList.length > 0 && !casinopreload">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="text-center">
                    <i class="preload-end fa fa-circle" aria-hidden="true"></i>&nbsp;
                    <i class="preload-end fa fa-circle" aria-hidden="true"></i>&nbsp;
                    <i class="preload-end fa fa-circle" aria-hidden="true"></i>&nbsp;
                  </div>
                </div>
              </div>
              <div id="scrollTop" class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <i class="fa fa-arrow-up" aria-hidden="true"></i>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
